import {
    REFEREE_POST_FAILURE,
    REFEREE_POST_REQUEST,
    REFEREE_POST_SUCCESS,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type, referee} = action;
    switch (type) {
        case REFEREE_POST_SUCCESS: {return {
            ...initialState,
            referee,
        }}

        case REFEREE_POST_REQUEST: {return {
            ...initialState,
            posting: true,
        }}

        case REFEREE_POST_FAILURE: {return {
            ...initialState,
            posting: false,
            hasErrors: true,
        }}

        default: {return state}
    }
};
